export default __webpack_public_path__ + "static/media/import-student-sample.3e633937.xlsx";